import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { Dropdown } from 'bootstrap';

const initialState = {
  categories: {}, 
  loading: false,
  error: null,
  pagination: {} 
};

/* ================== THUNKS ================== */

export const fetchCategoryTree = createAsyncThunk(
  'category-level/fetch',
  async ({ fetchType="table", page = 1, limit = 10, search = '', type }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/api/admin/level-categories', {
        params: { fetchType, page, limit, search }
      });
      return {
        fetchType, 
        data: response.data?.data?.records || [],
        pagination: response.data?.data?.pagination || {},
      };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const createCategoryTree = createAsyncThunk(
  'category-level/create',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        '/api/admin/level-categories', 
        payload
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const updateCategoryTree = createAsyncThunk(
  'category-level/update',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      console.log(id,'id');
      const response = await axiosInstance.put(`/api/admin/level-categories/${id}`, formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const deleteCategoryTree = createAsyncThunk(
  'category-level/delete',
  async ({ id, type }, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/api/admin/level-categories/${id}`);
      return { id, type };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

/* ================== SLICE ================== */

const categoryTreeSlice = createSlice({
  name: 'category-level',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* FETCH */
      .addCase(fetchCategoryTree.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategoryTree.fulfilled, (state, action) => {
        const { fetchType, type, data, pagination } = action.payload;
        state.loading = false;
        if(fetchType === "dropdown"){
          state.categories = data;
        }else{
          if (action.meta.arg.page === 1) {
            state.categories = data || [];
          } else {
            state.categories = [...state.categories, ...data];
          }
        }

        state.pagination = pagination;
      })
      .addCase(fetchCategoryTree.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* CREATE */
      .addCase(createCategoryTree.fulfilled, (state, action) => {
        state.categories = [
          ...(state.categories || []),
          action.payload
        ];
      })

      /* UPDATE */
      .addCase(updateCategoryTree.fulfilled, (state, action) => {
        console.log(state,'state');
      })

      /* DELETE */
      .addCase(deleteCategoryTree.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.categories = state.categories.filter(
          cat => cat._id !== id
        );
      });
  }
});

export default categoryTreeSlice.reducer;